import React from 'react';

import {
    Box,
    Typography,
} from '@mui/material';
import Divider from '@mui/material/Divider';



export default function ControlFeedback(props) {

    const { children } = props
    return (
        <React.Fragment>
            <Box
                display='flex'
                justifyContent='center'
                alignItems='center'
                // width='70px'
                textAlign='center'
            >
                {children}
            </Box>
        </React.Fragment>
    )
}